import axios from 'axios'
import store from '../store/index'
 
// 1、 返回一个唯一的标识符
export const jsuuid =()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}
export const getWeek =(DTTM)=> {
  const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const date = new Date(DTTM);
  const weekday = date.getDay();
  return  weekDays[weekday];
}
export const jsuuid2 =(len,radix)=>{ //长度，基数（2进制，10进制，16进制）
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split(''); 
  var uuid:any = [], i; 
  radix = radix || chars.length; 
  
  if (len) { 
    // Compact form 
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random()*radix]; 
  } else { 
    // rfc4122, version 4 form 
    var r; 
  
    // rfc4122 requires these characters 
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'; 
    uuid[14] = '4'; 
  
    // Fill in random data.  At i==19 set the high bits of clock sequence as 
    // per rfc4122, sec. 4.1.5 
    for (i = 0; i < 36; i++) { 
      if (!uuid[i]) { 
        r = 0 | Math.random()*16; 
        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]; 
      } 
    } 
  } 
  return uuid.join(''); 
}
export const uuid =()=>{ 
  var d = new Date()
  var time = d.getFullYear() + "-" +(d.getMonth()+1) + "-" + d.getDate() + "-" + d.getHours() + "-" + d.getMinutes() + "-" + d.getSeconds();
  return time
}
  
// 2 、带参数的数据集
 
export const paramData =(url,key,value,key2,value2,table,cond) =>{  
  return axios(url, {
    method:'post',
    data:{p_key:key,p_value:value,p_key2:key2,p_value2:value2,p_table:table ,p_cond:cond}
  })
}
const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}
//3 、返回系统当前日期
export const getDate = (startType) => {
  const d = new Date()
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (startType === 'year') resStr = year +'-'+ month + '-'+ date  +'-'+ hours +'-'+ minutes +'-'+ second
  else if (startType === 'full') resStr = year +'-'+ month + '-'+ date  +' '+ hours +':'+ minutes +':'+ second
  else if (startType === 'yr') resStr = year+''
  else if (startType === 'month') resStr = year+'-'+month
  else resStr = year + '-' + month + '-' + date
  return resStr
}  
//4 、返回系统当前日期
export const getDate2 = (day) => {
 
  const d = new Date(new Date().getTime()-day*24*60*60*1000) 
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  let resStr =  year + '-' + month + '-' + date
  return resStr
} 
export const getCurrentDay = () => {
  const d = new Date()
  const year = d.getFullYear()
  const month =  d.getMonth() + 1 
  const date =  d.getDate() 
  let resStr =  year + '-' + month + '-' + date
  return resStr
} 

export const getCurrentMth = () => {
  const d = new Date()
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1 )
  let resStr =  year + '-' + month 
  return resStr
} 
export const baseCascade =(url,value) =>{  
  return axios(url, {
    method:'post',
    data:{p_key:'parentno',p_value:value,p_table:'v_sys_base' }
  })
} 
 
export const format_number= (n)=>{
  var str_n=n.toString();
  var result="";
  while(str_n.length>3){
    result=","+str_n.slice(-3)+result;
    str_n=str_n.slice(0,str_n.length-3)
  }
  if(str_n){
    return(str_n+result)
  }
}
//两个日期字符串比较
export const getDaysDifference= (dateString1, dateString2)=>{
  if(!
    dateString1 || !dateString2
    ) {
    return ""
  }
  var date1 = new Date(dateString1)
  var date2 = new Date(dateString2)
  // 计算毫秒差值  绝对值
  var difference = Math.abs(date1.getTime() - date2.getTime())
  // 将毫秒差值转换为天数  四舍五入
  var daysDifference = Math.round(difference / (1000 * 60 * 60 * 24))
  return daysDifference + ""
}

// 年-月 + 多少天后 得到 那个月份的最后一天
export const getLastDay= (yearMonthStr,days)=>{
  //1、解析 "yyyy-mm"
  const parts =yearMonthStr.split('-')
  const year=parseInt(parts[0],10)
  const month =parseInt(parts[1],10) -1 ; //js 月份从0开始
  // 获取该月的最后一天作为基准日期
  const baseDate =new Date(year,month+1,0) 
  // 加上天数
  baseDate.setDate(baseDate.getDate()+Number(days) )
  //获取加完天数后，所在月份的最后一天
  const targetYear =baseDate.getFullYear()
  const targetMonth=baseDate.getMonth() //此时是加完多少天后的月份
  //再次利用 setDate(0) 技巧获取当月最后一天
  const finalDate =new Date(targetYear,targetMonth+1,0)
  //5、格式化输出 yyyy-mm-dd
  const y = finalDate.getFullYear()
  const m =String(finalDate.getMonth()+1).padStart(2,'0')
  const d =String(finalDate.getDate()).padStart(2,'0')
  return `${y}-${m}-${d}`
}
  